// extracted by mini-css-extract-plugin
module.exports = {"container":"MemberSelect_container_1uE_f","label":"MemberSelect_label_m3dlu"};